// /context/SpinnerContext.js

import React, { createContext, useState, useContext } from 'react';
import styled, { keyframes } from 'styled-components';
const SpinnerContext = createContext();

// Spinner animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Overlay container
const SpinnerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Spinner itself
const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 8px solid #ccc;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const SpinnerText = styled.div`
  margin-top: 16px;
  font-size: 1.2rem;
  color: #333;
`;


export const SpinnerProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return (
    <SpinnerContext.Provider value={{ loading, setLoading }}>
      {children}
      {loading && (
        <SpinnerOverlay>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Spinner />
            <SpinnerText>Processing...</SpinnerText>
          </div>
        </SpinnerOverlay>
      )}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => useContext(SpinnerContext);

